import { ref } from 'vue';

export const useVisibility = (defaultVisibility = false) => {
  const visible = ref(defaultVisibility);
  const hide = () => (visible.value = false);
  const show = () => (visible.value = true);
  const toggleVisibility = () => (visible.value = !visible.value);

  return {
    visible,
    hide,
    show,
    toggleVisibility,
  };
};

export const useMultiVisibility = (defaultVisibility = {}) => {
  // Состояние видимости для каждого элемента
  const visibility = ref({ ...defaultVisibility });

  // Показать конкретный элемент
  const show = (key) => {
    if (!key) return;
    visibility.value[key] = true;
  };

  // Скрыть конкретный элемент
  const hide = (key) => {
    if (!key) return;
    visibility.value[key] = false;
  };

  // Переключить видимость конкретного элемента
  const toggleVisibility = (key) => {
    console.log('toggleVisibility213123', key);
    if (!key) return;
    visibility.value[key] = !visibility.value[key];
  };

  // Получить состояние видимости для элемента
  const isVisible = (key) => visibility.value[key] || false;

  return {
    visibility,
    show,
    hide,
    toggleVisibility,
    isVisible,
  };
};
